var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.clients,"item-text":_vm.labelOf,"item-value":"abbr","label":"Kunde","return-object":""},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})
}
var staticRenderFns = []

export { render, staticRenderFns }